// Program Configuration Data
const programData = {
  programs: [
    {
      id: 1,
      title: "Potty Training",
      description: "14 Day Program",
      image: "//wiglo.dog/cdn/shop/t/1/assets/potty.svg?v=111714601848357415721767108318",
      relatedGroups: ["potty"]
    },
    {
      id: 2,
      title: "Solve reactivity",
      description: "21 Day Program",
      image: "//wiglo.dog/cdn/shop/t/1/assets/reactivity.svg?v=133623293492968983541767108318",
      relatedGroups: ["reactivity"]
    },
    {
      id: 3,
      title: "Solve separation anxiety",
      description: "28 Day Program",
      image: "//wiglo.dog/cdn/shop/t/1/assets/separation.svg?v=173182934473496411571767108318",
      relatedGroups: ["separation"]
    },
    {
      id: 4,
      title: "Stop scavenging",
      description: "14 Day Program",
      image: "//wiglo.dog/cdn/shop/t/1/assets/scavenging.svg?v=178860177687859806141767108318",
      relatedGroups: ["scavenging"]
    },
    {
      id: 5,
      title: "Recall training",
      description: "21 Day Program",
      image: "//wiglo.dog/cdn/shop/t/1/assets/recall.svg?v=112237258618919649921767108318",
      relatedGroups: ["recall"]
    },
    {
      id: 6,
      title: "Stop leash pulling",
      description: "14 Day Program",
      image: "//wiglo.dog/cdn/shop/t/1/assets/leash.svg?v=45051577734448316781767108315",
      relatedGroups: ["leash"]
    },
    {
      id: 7,
      title: "Build a strong bond ",
      description: "14 Day Program",
      image: "//wiglo.dog/cdn/shop/t/1/assets/bond.svg?v=142464372161672048071767108312",
      relatedGroups: ["bond"]
    },
    {
      id: 8,
      title: "Solve attention seeking",
      description: "7 Day Program",
      image: "//wiglo.dog/cdn/shop/t/1/assets/attention.svg?v=150826573560972539521767108277",
      relatedGroups: ["attention"]
    },
    {
      id: 9,
      title: "Solve jumping",
      description: "12 Day Program",
      image: "//wiglo.dog/cdn/shop/t/1/assets/jumping.svg?v=184357674015600150611767108315",
      relatedGroups: ["jumping"]
    },
    {
      id: 10,
      title: "Solve puppy biting",
      description: "Theory Guide",
      image: "//wiglo.dog/cdn/shop/t/1/assets/biting.svg?v=117235952943911435991767108312",
      relatedGroups: ["biting"]
    },
    {
      id: 11,
      title: "Puppy socialization & basics",
      description: "8 Week Program",
      image: "//wiglo.dog/cdn/shop/t/1/assets/socialization.svg?v=163528362405576818101767108318",
      relatedGroups: ["socialization"]
    },
    {
      id: 12,
      title: "Crate training",
      description: "14 Day Program",
      image: "//wiglo.dog/cdn/shop/t/1/assets/crate.svg?v=24769945450690217711767108312",
      relatedGroups: ["crate"]
    },
    {
      id: 13,
      title: "Keep a dog off your bed",
      description: "7 Day Program",
      image: "//wiglo.dog/cdn/shop/t/1/assets/bed.svg?v=11264932527517365211767108312",
      relatedGroups: ["bed"]
    },
  ]
};
